import React, { useContext, useRef } from 'react';
import { StyleSheet, Text } from 'react-native';
import PropTypes from 'prop-types';
import LayoutContext from '../../contexts/Layout';
import { useOverflowStyle } from '../../hooks/useOverflowStyle';
import useDynamicFontSize from '../../hooks/useDynamicFontSize';

const H1 = ({ style = {}, text, ...rest }) => {
    const { layout } = useContext(LayoutContext);
    const ref = useRef();
    const overflowStyle = useOverflowStyle(ref, layout.styleGuide.h1);
    const { calculateFontSize } = useDynamicFontSize();

    if (!text) {
        return;
    }

    return (
        <Text
            {...rest}
            adjustsFontSizeToFit={true}
            dataSet={{
                ...rest.dataSet,
                tagName: 'H1',
                fontFamily: layout.styleGuide.h1.fontFamily,
                condensedFontFamily: layout.styleGuide.h1.condensedFontFamily,
                fontSize: layout.styleGuide.h1.fontSize,
                color: layout.styleGuide.h1.color
            }}
            numberOfLines={1}
            onLayout={e => {
                //if (overflowStyle && (overflowStyle.fontFamily !== layout.styleGuide.h1.fontFamily)) {
                const dimensions = {
                    height: e.nativeEvent.layout.height,
                    width: e.nativeEvent.layout.width
                };

                if (layout.device.os.equals('web')) {
                    ref.current.style['font-size'] = calculateFontSize(layout.styleGuide.h1.fontSize, dimensions, text.length);
                }
                //}
            }}
            ref={ref}
            style={StyleSheet.flatten([Style.h1, layout.styleGuide.h1, overflowStyle, style])}
        >
            {text}
        </Text>
    );
};

const Style = StyleSheet.create({
    h1: {
        color: '#000',
        fontFamily: 'GothamBook',
        fontSize: '32pt'
    }
});

H1.propTypes = {
    text: PropTypes.string
};

export default H1;
